import { TRADITIONS, SISTER_BRAND_URL } from "@/lib/constants";
import RecipeDivider from "./RecipeDivider";

const accentMap = {
  rose: "hsl(var(--rose-deep))",
  sage: "hsl(var(--sage-deep))",
  gold: "hsl(var(--gold-deep))",
};

export default function Traditions() {
  return (
    <section
      id="traditions"
      data-testid="traditions-section"
      className="section bg-cream"
    >
      <div className="mx-auto max-w-7xl">
        <div className="text-center max-w-3xl mx-auto">
          <span className="eyebrow">culinary traditions</span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
            A table shaped by{" "}
            <span className="font-script text-[hsl(var(--sage-deep))]">
              many
            </span>{" "}
            traditions.
          </h2>
          <p className="mt-4 text-[hsl(var(--brown-soft))]">
            Choose one tradition or weave several together. Our menus are
            designed around your gathering, not the other way around.
          </p>
          <div className="mt-6">
            <RecipeDivider />
          </div>
        </div>

        <div className="mt-12 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
          {TRADITIONS.map((t, i) => (
            <article
              key={t.id}
              data-testid={`tradition-card-${t.id}`}
              className="recipe-card overflow-hidden group flex flex-col"
              style={{
                animation: `floatin 0.8s ${i * 0.05}s ease-out both`,
              }}
            >
              <div className="relative h-44 overflow-hidden m-[6px] rounded-t-[0.95rem]">
                <img
                  src={t.image}
                  alt={t.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(180deg, transparent 40%, hsl(28 22% 16% / 0.5) 100%)",
                  }}
                />
                <div className="absolute bottom-3 left-4">
                  <span
                    className="font-script text-2xl"
                    style={{ color: "hsl(var(--cream))" }}
                  >
                    {t.script}
                  </span>
                </div>
              </div>

              <div className="px-6 pt-3 pb-6 flex flex-col flex-1">
                <h3
                  className="font-serif-display text-2xl"
                  style={{ color: accentMap[t.accent] }}
                >
                  {t.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[hsl(var(--brown-soft))] flex-1">
                  {t.description}
                </p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {t.notes.map((n) => (
                    <span key={n} className="tradition-chip">
                      {n}
                    </span>
                  ))}
                </div>
                {t.isSisterBrand ? (
                  <a
                    href={SISTER_BRAND_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="tradition-dessert-link"
                    className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[hsl(var(--gold-deep))] hover:text-[hsl(var(--rose-deep))] transition-colors"
                  >
                    Explore Central Florida Custom Cakes
                    <span aria-hidden>→</span>
                  </a>
                ) : (
                  <a
                    href="#quote"
                    className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[hsl(var(--rose-deep))] hover:text-[hsl(var(--brown))] transition-colors"
                  >
                    Plan a menu like this
                    <span aria-hidden>→</span>
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
